import logo from './logo.svg';
import './App.css';
import HomePage from './Pages/homepage'
import SingleProperty from './Pages/SinglePorperty';
import { BrowserRouter, Routes, Route } from "react-router-dom";
function App() {
  return (
    <>
      <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage/>}/>
              <Route path="/property" element={<SingleProperty/>}/>
              
            </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
